<template>
  <section >




      <v-card>
        <v-toolbar dark color="orange darken-4">
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items >
        
            <v-btn dark flat @click="volver()" >
              <v-icon dark>close</v-icon>
            </v-btn>
            <div class="primary" style="background-color: #e65100" color="primary">
          <v-tooltip  bottom>
            <v-btn  class="btn-flotante-save" slot="activator" fixed top right fab dark small color="accent"  @click.native="dialogAddPrueba = false" @click="submitTest(prueba)">
              <v-icon dark>save</v-icon>
            </v-btn>
            <span>Guardar</span>
          </v-tooltip>
          <v-tooltip bottom>
                      <v-btn  class="btn-flotante" slot="activator" style="margin-top: 15%;" fixed top right fab dark small color="accent"  @click="addPregunta(evaluacion, index)">
                        <v-icon dark>add</v-icon>
                      </v-btn>
                       <span>Nueva Pregunta</span>
                    </v-tooltip>
            </div>
          </v-toolbar-items>
        </v-toolbar>
           <v-container grid-list-xl text-xs-center>
              <v-layout row wrap>
                <v-flex xs10 offset-xs1>
                  <v-card color="grey lighten-2" class="primary--text">
                    <v-card-title primary-title>
                      <p class="accent--text display-1">Nueva Prueba</p>
                       <v-flex xs12>
                         <v-subheader class="secondary--text mt-2 pt-4" >Titulo de la Evaluación</v-subheader>
                          <v-text-field class="mb-2 mt-0"
                            name="input-1-3"
                            single-line
                            label="Titulo "
                            v-model="evaluacion.section.section_title"
                            box
                            solo
                            color="black"
                          ></v-text-field>
                          <v-subheader class="secondary--text mt-2 pt-4" >Unidad de la Evaluación</v-subheader>
                          <v-select class="mb-2"
                            :label="evaluacion.section.unity.unity_name"
                            v-model="evaluacion.section.unity.unity_name"
                            :items="unidades"
                            item-text="unity_name"
                            item-value="id"
                            required
                            solo
                            color="black"
                      ></v-select>
                        </v-flex>
                         <v-flex xs12>
                            <v-subheader class="secondary--text mt-2 pt-4" >Descripción de la Evaluación</v-subheader>
                            <v-text-field class="mb-2"
                              name="input-1-3"
                              single-line
                              v-model="evaluacion.test_description"
                              solo
                              box
                              color="black"
                              multi-line
                            ></v-text-field>
                          </v-flex>
                          <!-- <v-subheader class="secondary--text mt-2 pt-4 ml-3" >Tipo de Evaluación</v-subheader>
                          <v-flex xs12 class="mx-4" style="background-color:white;">
                          <v-radio-group v-model="configRespuesta" row>
                            <v-radio label="Mostrar respuestas"  value="radio-1"></v-radio>
                            <v-radio label="Mostrar cantidad buenas" value="radio-2"></v-radio>
                            <v-radio label="No mostrar nada" value="radio-3"></v-radio>
                          </v-radio-group>
                          </v-flex>-->
                          <v-subheader class="secondary--text ml-3 pt-4" >Ajustes</v-subheader>
                          <v-flex xs12 class="mx-2" style="background-color:white;">
                            <v-radio-group v-model="evaluacionTipoGuardada"  class="px-3" row :mandatory="false">
                                      <template v-for="evaluada in evaluacionTipos"> 
                                        
                                        <v-radio class="primary--text"  :label="evaluada.type_test_nombre" :value="evaluada.id"></v-radio>
                                      </template>
                                    </v-radio-group>
                          <!-- <v-radio-group v-model="ex8" class="px-3" :mandatory="false">
                                      <template v-for="tipoEvaluacion in evaluacion.questions[index].alternatives"> 
                                        <v-radio class="primary--text" :label="tipoEvaluacion.alternative_test" :value="alternativa.id"></v-radio>
                                      </template>
                                    </v-radio-group> -->
                          <v-container fluid grid-list-xl>
                          <v-layout wrap align-center>
                             <v-flex xs12 sm8 d-flex>
                               
                           <v-switch
                            label="Con puntaje"
                            :value="true"
                            v-model="conPuntajeEvaluacion"
                            :change="actualizarConPuntaje()"
                          ></v-switch>
                             </v-flex>
                             <v-flex xs12 sm4 d-flex>
                          <v-select xs8
                          :items="calificaciones"
                          item-value="id"
                          item-text="qualification_content"
                          append-outer-icon="add"
                          append-icon="exposure"
                          label="Ponderación"
                          solo
                          ></v-select>
                          
                          </v-flex>
                          </v-layout>
                          </v-container>
                          </v-flex>
                    </v-card-title>
                     <div v-if="evaluacion.questions.length !== 0">
                      <p class="accent--text display-1 my-4">Sección de preguntas</p></div>
                      <template v-for="(item,index) in evaluacion.questions">
                        <v-container grid-list-md text-xs-center>
                          <v-layout row wrap >
                            
                            <v-flex class="ml-4 mr-4">

                              <div  style="text-align: center !important; background-color: #757575; padding-top: 10px; padding-bottom: 10px" class="white--text accent"><strong>Pregunta {{ index + 1 }}</strong></div>
                         <v-container fluid grid-list-xl>
                          <v-layout wrap align-center>
                            <!-- <v-subheader class="secondary--text ">Ingresar Pregunta</v-subheader> -->
                             <v-flex xs12 sm8 >
                              <v-text-field
                                name="input-1-3"
                                label="Pregunta"
                                single-line
                                v-model="evaluacion.questions[index].question_text"
                                solo
                                box
                                color="black"
                                multi-line
                                rows="2"
                              ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm4 d-flex>
                                
                              <v-select
                                :items="preguntaTipos"
                                box
                                solo
                                v-on:change="addAlternativa(evaluacion, index)"
                                :defaultValue="evaluacion.questions[index].type_question_id"
                                item-text="type_question_name"
                                append-outer-icon="add"
                                item-value="id"
                                v-model="evaluacion.questions[index].type_question_id"
                                label="Tipo Respuesta"
                              ></v-select>
                              
                            </v-flex>
                          </v-layout>
                         </v-container >
                         <!-- evaluacion.questions[index].type_question_id -->
                         <!-- Casilla -->
                            <v-layout row wrap v-if="evaluacion.questions[index].type_question_id === 4">
                              <v-flex xs12 sm12 md8 lg8 xl8 offset-xs0 offset-sm0 offset-lg0 offset-md0>
                               
                              <template v-for="(item,index2) in evaluacion.questions[index].response_option">
                                <v-layout row  >
                                 <v-flex xs1 style="padding: 0px!important">
                                  <span class="white--text">{{ index2 + 1 }}</span>
                                </v-flex>
                                 <v-flex xs9 style="padding: 0px!important">
                                  <v-text-field
                                    name="input-1-3"
                                    single-line
                                    solo
                                    box
                                    style="padding: 0px !important"
                                    color="black"
                                    v-model="evaluacion.questions[index].response_option[index2].response_options_test"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs2 style="padding: 0px!important">
                                  <v-btn @click="removeAlternativa(index,index2)" flat icon color="red" style="margin: 0px!important">
                                    <v-icon>delete</v-icon>
                                  </v-btn>
                                </v-flex>
                                </v-layout>
                              </template>
                              <v-flex xs12>
                               <v-btn @click="addAlternativa(evaluacion, index)"  color="primary">agregar nueva Respuesta</v-btn>
                               
                                </v-flex>
                                </v-flex>
                                <v-flex xs12 sm12 md4 lg4 xl4 offset-xs0 offset-sm0 offset-lg0 offset-md0>
                                  <v-flex xs12>                                    
                                    <span class="white--text">Seleccione alternativas correctas</span>
                                  <!--  <v-radio class="color-primary " :label="item2.alternative_test" :value="item2.id"></v-radio> -->
                                  <!--  <v-select
                                      v-model="evaluacion.questions[index].response_options_test.alternative_test"
                                      multiple
                                      tags
                                      color="white"
                                      solo
                                      :label="evaluacion.questions[index].question_alternative_correct"
                                      hint="Selecciona las alternativas correctas"
                                      :items="item.alternatives"
                                    ></v-select>-->
                                     <v-card>
                                     
                                    <template v-for="(value, key, index3) in evaluacion.questions[index].response_option">
                                        <v-checkbox class="ml-2 pt-2" v-model="preguntaCasilla[index]" :label="value.response_options_test" :value="value.id"></v-checkbox>

                                    </template>
                                    </v-card>  
                                  </v-flex>
                                  <v-flex xs12 v-if="evaluacion.est_point_status==true">
                                    <v-subheader class="secondary--text mt-2 pt-4" >Puntaje</v-subheader>
                                    <v-text-field
                                        name="input-1-3"
                                        type="numeric"
                                        single-line
                                        dark
                                        color="white"
                                        label="Puntaje Pregunta"
                                        v-model="evaluacion.questions[index].questions_point"
                                      ></v-text-field>
                                  </v-flex>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap v-if="evaluacion.questions[index].type_question_id === 1">
                              <v-flex xs8 >
                                <v-text-field
                                        name="input-1-3"
                                        type="numeric"
                                        single-line
                                        solo
                                        color="white"
                                        label="Ingrese la respuesta ideal"
                                        v-model="respuestaBreve"
                                      ></v-text-field>
                                </v-flex>
                                 <v-flex xs4 v-if="evaluacion.est_point_status==true">
                                   <v-subheader class="secondary--text ml-3 pt-4" >Puntaje</v-subheader>
                                <v-text-field
                                        name="input-1-3"
                                        type="numeric"
                                        single-line
                                        dark
                                        color="white"
                                        label="Puntaje Pregunta"
                                        v-model="evaluacion.questions[index].questions_point"
                                      ></v-text-field>
                                </v-flex>
                              </v-layout>
                              <!-- Respuesta Breve -->
                              
                               <v-layout row wrap v-if="evaluacion.questions[index].type_question_id === 2">
                                 
                              <v-flex xs8 >
                                <v-text-field
                                        name="input-1-3"
                                        type="numeric"
                                        multi-line
                                        solo
                                        color="white"
                                        label="Ingrese la respuesta ideal"
                                        v-model="respuestaParrafo"
                                      ></v-text-field>
                                </v-flex>
                                <v-flex xs4 v-if="evaluacion.est_point_status==true" >
                                  <v-subheader class="secondary--text ml-3 pt-4" >Puntaje</v-subheader>
                                <v-text-field
                                        name="input-1-3"
                                        type="numeric"
                                        single-line
                                        dark
                                        color="white"
                                        label="Puntaje Pregunta"
                                        v-model="evaluacion.questions[index].questions_point"
                                      ></v-text-field>
                                </v-flex>
                              </v-layout>
                              
                              <!-- opcion -->
                              <v-layout row wrap v-if=" evaluacion.questions[index].type_question_id === 3">
                              <v-flex xs12 sm12 md8 lg8 xl8 offset-xs0 offset-sm0 offset-lg0 offset-md0>
                              <template v-for="(item,index2) in evaluacion.questions[index].response_option">
                                <v-layout row  >
                                 <v-flex xs1 style="padding: 0px!important">
                                  <span class="white--text">{{ index2 + 1 }}</span>
                                </v-flex>
                                 <v-flex xs9 style="padding: 0px!important">
                                  <v-text-field
                                    name="input-1-3"
                                    single-line
                                    solo
                                    box
                                    style="padding: 0px !important"
                                    color="black"
                                    v-model="evaluacion.questions[index].response_option[index2].response_options_test"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs2 style="padding: 0px!important">
                                  <v-btn @click="removeAlternativa(index,index2)" flat icon color="red" style="margin: 0px!important">
                                    <v-icon>delete</v-icon>
                                  </v-btn>
                                </v-flex>
                                </v-layout>
                              </template>
                              <v-flex xs12>
                               <v-btn @click="addAlternativa(evaluacion, index)"  color="primary">agregar nueva REspuesta</v-btn>
                                </v-flex>
                                </v-flex>
                                <v-flex xs12 sm12 md4 lg4 xl4 offset-xs0 offset-sm0 offset-lg0 offset-md0>
                                  <v-flex xs12>
                                    
                                    <span class="white--text">Seleccione la alternativa correcta</span>
                                  <!--  <v-radio class="color-primary " :label="item2.alternative_test" :value="item2.id"></v-radio> -->
                                   <v-card> 
                                     <!-- Cambiar modelo del radio Group -->
                                     <!-- :change="addAlternativaCorrecta(index, preguntaOpcion[index])" -->
                                     
                                    <v-radio-group v-model="preguntaOpcion[index]" class="px-3"  :mandatory="false">
                                      <template v-for="alternativa in evaluacion.questions[index].response_option"> 
                                        <v-radio class="primary--text" :label="alternativa.response_options_test" :value="alternativa.id"></v-radio>
                                      </template>
                                    </v-radio-group>
                                    </v-card>
                                  </v-flex>
                                  <v-flex xs12 v-if="evaluacion.est_point_status==true">
                                    <v-subheader class="secondary--text ml-3 pt-4" >Puntaje</v-subheader>
                                    <v-text-field
                                        name="input-1-3"
                                        type="numeric"
                                        single-line
                                        dark
                                        color="white"
                                        label="Puntaje Pregunta"
                                        v-model="evaluacion.questions[index].questions_point"
                                      ></v-text-field>
                                  </v-flex>
                                </v-flex>
                              </v-layout>

                              <!-- SAP -->
                              <v-layout row wrap v-if="evaluacion.questions[index].type_question_id === 5">
                              <v-flex xs12 sm12 offset-xs0 offset-sm0 offset-lg0 offset-md0>
                                <v-layout row >
                                  <v-flex xs12 sm5 md3>
                                <v-card dark color="primary">
                                <p  class=" subheading white--text">Codígo</p>
                                </v-card>
                                </v-flex>
                                <v-flex xs12 sm5 md3>
                                <v-card dark color="primary">
                                <p class="subheading white--text">Transacción</p>
                                </v-card>
                                </v-flex>
                                <v-flex xs12 mx-3 sm5 md3>
                               <v-btn @click="addTransaccion(prueba, index)" class="white--text" color="accent">Agregar nueva Transacción</v-btn>
                            
                                </v-flex>
                                </v-layout>
                                <v-container >
                                  <v-layout>
                                  <v-flex xs6  > 
                                <template v-for="(item,index2) in item.response_option ">
                                  <v-layout row v-if="item.type_response_id == 1">
                                  <v-flex xs6 pl-0 >   
                                <v-text-field 
                                        name="input-1-3"
                                        type="numeric"
                                        disabled
                                        solo
                                        color="white"
                                        label=""
                                      ></v-text-field>
                                </v-flex>
                                <v-flex xs6>   
                                <v-text-field 
                                        name="input-1-3"
                                        type="numeric"
                                        disabled
                                        solo
                                        color="white"
                                        label=""
                                      ></v-text-field>
                                </v-flex>
                                <v-flex xs2 style="padding: 0px!important">
                                  <v-btn @click="removeTransaccion(index,index2)" flat icon color="red" style="margin: 0px!important">
                                    <v-icon>delete</v-icon>
                                  </v-btn>
                                </v-flex>
                                  </v-layout>
                                  </template>
                                   
                                  </v-flex>
                                  <v-flex xs4 offset-xs2 v-if="evaluacion.est_point_status==true">
                                    <v-subheader class="secondary--text mt-2 pt-4" >Puntaje</v-subheader>
                                     <v-text-field 
                                        name="input-1-3"
                                        type="numeric"
                                        single-line
                                        dark
                                        color="white"
                                        label="Puntaje Pregunta"
                                        v-model="evaluacion.questions[index].questions_point"
                                      ></v-text-field>
                                  </v-flex>
                                  </v-layout>
                                </v-container>
                                </v-flex>
                              </v-layout>


                              </v-flex>
                            </v-layout>
                          </v-container>
                         
                      </template> 
<!--                       <v-btn @click="addPregunta(prueba, index)" outline color="white">Agregar Nueva Pregunta</v-btn> -->
<template >
                    
                    </template>
                    
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
      </v-card>

    <v-dialog v-model="dialogCerrarPruebaConfirmacion" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Realmente desea salir?</v-card-title>
        <v-card-text>Se perderan todos los avances de la prueba.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange darken-1" flat @click.native="dialogCerrarPruebaConfirmacion = false" @click="dialogAddPrueba = false">aceptar</v-btn>
          <v-btn color="orange darken-1" flat @click.native="dialogCerrarPruebaConfirmacion = false" >cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



<v-snackbar
:timeout="timeout"
:color="colorSnackbar"
v-model="snackbar"
>
<v-icon dark>check_circle</v-icon>
{{ textSnackbar }}
<v-btn dark flat @click.native="snackbar = false">X</v-btn>
</v-snackbar>


</section>
</template>

<script>
  import { courceService } from '@/services/Cource.service'
  import { typeCompetitionService } from '@/services/TypeCompetition.service'
  import { nivelService } from '@/services/Nivel.service'
  import { getCategoriesPerUserService } from '@/services/categoria/GetCategoriesPerUser.service'
  import { getAllUnityOfCurseService } from '@/services/GetAllUnityOfCurse.service'
  import { getLessonsPerCourseService } from '@/services/leccion/GetLessonsPerCourse.service'
  import { testService } from '@/services/Test.service'
  import { getTestPerCourseService } from '@/services/prueba/GetTestPerCourse.service'
  import { typeLessonService } from '@/services/leccion/TypeLesson.service'
  import { changeTheStatusOfTheLessonService } from '@/services/leccion/ChangeTheStatusOfTheLesson.service'
  import { changeTheStatusOfTheTestService } from '@/services/prueba/ChangeTheStatusOfTheTest.service'
  import { questionsTypeService } from '@/services/prueba/TypeQuestions.service'
  import { evaluationTypeService } from '@/services/prueba/EvaluationType.service'
  import { getQualificationPerCourseService } from '@/services/Calificacion/GetQualificationPerCourse.service'
  
  export default {
    data () {
      return {
        idEvaluacion: 0,
        editable: true,
        unidades: [],
        pruebas: [],
        ex8: 0,
        evaluacionTipos: [],
        respuestaBreve: '',
        respuestaParrafo: '',
        evaluacion: {},
        unidad: {},
        lecciones: [],
        levels: [],
        configRespuesta: 0,
        eleccionRespuesta: '',
        opcionRespuesta: ['Respuesta breve', 'Párrafo', 'Opción', 'Casilla'],
        categorias: [],
        typeLesson: [],
        tipodeleccion: 0,
        lesson: {
          autor: {
            name: ''
          },
          section: {
            unity: {
              course: {
                cource_title: ''
              }
            }
          }
        },
        curso: {},
        pagination: {},
        title: '',
        valid: true,
        competicion: {},
        objetivo: {},
        objetivos: [],
        offsetTop: 0,
        archivo: {},
        idUnidad: 0,
        currentUnidad: {},
        dialogAddCompetencias: false,
        dialogAddObjetivos: false,
        dialogAddUnidades: false,
        dialogEditUnidades: false,
        dialogAddLecciones: false,
        dialogAddPrueba: false,
        dialogCerrarPruebaConfirmacion: false,
        states: [],
        typeCompetetences: [],
        competiciones: [],
        qwerty: ['as', 'asd', 'asdas'],
        tabs: [ 'Curso', 'Unidades', 'Lecciones', 'Evaluación', 'Competencias', 'Objetivos' ],
        active2: null,
        cantidadUnidades: 0,
        headers: [
          {
            text: '#',
            align: 'left',
            sortable: false,
            value: 'name'
          },
        { text: 'Unidad', value: 'unidad' },
        { text: 'Editar', value: 'editar' }
        ],
        snackbar: false,
        colorSnackbar: '',
        timeout: 6000,
        textSnackbar: '',
        headersUnidad: [
          { text: 'Posición', align: 'center', value: 'posicion', class: 'accent--text subheading ' },
          { text: 'Nombre', align: 'left', value: 'nombre', class: ' accent--text subheading' },
          { text: 'Editar', align: 'center', value: 'editar', class: ' accent--text subheading' },
          { text: 'Eliminar', align: 'center', value: 'eliminar', class: 'accent--text subheading' }
        ],
        headersLeccion: [
          { text: 'Nombre', align: 'left', value: 'nombre', class: 'accent--text subheading' },
          { text: 'Unidad', align: 'left', value: 'unidad', class: 'accent--text subheading' },
          { text: 'Estado', align: 'left', value: 'estado', class: 'accent--text subheading' },
          { text: 'Ver', align: 'center', value: 'editar', class: 'accent--text subheading' },
          { text: 'Eliminar', align: 'center', value: 'eliminar', class: 'accent--text subheading' }
        ],
        headersPrueba: [
          { text: 'Nombre', align: 'left', value: 'nombre', class: 'accent--text subheading' },
          { text: 'Unidad', align: 'left', value: 'unidad', class: 'accent--text subheading' },
          { text: 'Estado', align: 'left', value: 'estado', class: 'accent--text subheading' },
          { text: 'Ver', align: 'center', value: 'editar', class: 'accent--text subheading' },
          { text: 'Eliminar', align: 'center', value: 'eliminar', class: 'accent--text subheading' }
        ],
        tmp: '',
        search: '',
        prguntasNuevas: [],
        preguntaTipos: [],
        pregunta: {
          texto: 'Pregunta',
          alternativas: [],
          select: [],
          puntaje: 'Puntaje Pregunta'
        },
        alternativa: {
          textoAlternativa: 'Opción 1'
        },
        prueba: {
          titulo: 'Titulo de la Prueba',
          descripcion: 'Descripción de la prueba',
          unity_id: 1,
          preguntas: []
        },
        acctionDelete: '',
        dialogDeleteElement: false,
        elementDelete: '',
        preguntaOpcion: [{
          correcta: 0
        }],
        preguntaCasilla: [],
        correctasCasillas: [],
        preguntasAuxOpcion: [{
          correcta: {},
          opcionesRespuesta: [{
          }]
        }],
        evaluacionTipoGuardada: 0,
        conPuntajeEvaluacion: false,
        calificaciones: []
      }
    },
    methods: {
      loadCurso () {
        let vm = this
        courceService.getById(vm.idCurso).then(data => {
          vm.curso = data.body
          vm.competiciones = data.body.competences
          vm.objetivos = data.body.objectives
          vm.loadCalificaciones()
        })
      },
      loadCalificaciones () {
        let vm = this
        getQualificationPerCourseService.getById(vm.idCurso).then(data => {
          vm.calificaciones = data.body
          vm.calificacion_id = data.body[0].id
          // vm.loadmiembrosDelCurso(vm.calificacion_id)
        })
      },
      loadEvaluacionesTipo () {
        let vm = this
        evaluationTypeService.query().then(data => {
          vm.evaluacionTipos = data.body
        })
      },
      loadTipoCompetencia () {
        let vm = this
        typeCompetitionService.query().then(data => {
          vm.typeCompetetences = data.body
        })
      },
      loadNiveles () {
        let vm = this
        nivelService.query().then(data => {
          vm.levels = data.body
        })
      },
      loadCategorias () {
        let vm = this
        getCategoriesPerUserService.query().then(data => {
          vm.categorias = data.body
        })
      },
      loadTypeLesson () {
        let vm = this
        typeLessonService.query().then(data => {
          vm.typeLesson = data.body
        })
      },
      loadUnidades (id) {
        let vm = this
        getAllUnityOfCurseService.getById(id).then(data => {
          vm.unidades = data.body
        })
      },
      loadLecciones (id) {
        let vm = this
        getLessonsPerCourseService.getById(id).then(data => {
          vm.lecciones = data.body
        })
      },
      loadPreguntasTipo () {
        let vm = this
        questionsTypeService.query().then(data => {
          vm.preguntaTipos = data.body
        })
      },
      loadPruebas (id) {
        let vm = this
        getTestPerCourseService.getById(id).then(data => {
          vm.pruebas = data.body
        })
      },
      loadPrueba () {
        let vm = this
        testService.getById(vm.idEvaluacion).then(data => {
          vm.evaluacion = data.body
          vm.cantidadPreguntas = data.body.questions.length
          vm.cargarCasillaCorrectas()
          vm.cargarOpcionCorrecta()
          vm.loadTipoEvaluacion()
          vm.loadConPuntaje()
        })
      },
      loadConPuntaje () {
        let vm = this
        if (vm.evaluacion.test_point_status === 1) {
          vm.conPuntajeEvaluacion = true
        } else {
          vm.conPuntajeEvaluacion = false
        }
      },
      actualizarConPuntaje () {
        let vm = this
        if (vm.conPuntajeEvaluacion === null) {
          vm.conPuntajeEvaluacion = false
          vm.evaluacion.test_point_status = 0
        } else {
          vm.evaluacion.test_point_status = 1
        }
      },
      loadTipoEvaluacion () {
        let vm = this
        if (vm.evaluacion.typeTest_id === 1) {
          vm.evaluacionTipoGuardada = 1
        } else {
          vm.evaluacionTipoGuardada = 2
        }
      },
      cargarOpcionCorrecta () {
        let vm = this
        var index
        var index2
        for (index in vm.evaluacion.questions) {
          if (vm.evaluacion.questions[index].type_question_id === 3) {
            for (index2 in vm.evaluacion.questions[index].response_option) {
              if (vm.evaluacion.questions[index].response_option[index2].response_option_correct === 1) {
                vm.preguntaOpcion[index] = vm.evaluacion.questions[index].response_option[index2].id
              }
            }
          }
        }
        // vm.preguntaOpcion = vm.evaluacion.questions[index].response_option[aux]
      },
      cargarCasillaCorrectas () {
        let vm = this
        var index
        var vacio = []
        for (index in vm.evaluacion.questions) {
          if (vm.evaluacion.questions[index].type_question_id === 4) {
            vm.encontrarCasillaCorrectas(index)
            vm.preguntaCasilla.push(vm.correctasCasillas)
            vm.correctasCasillas = []
            // vm.preguntaCasilla[index] = vm.correctasCasillas
          } else {
            vm.preguntaCasilla.push(vacio)
          }
        }
      },
      encontrarCasillaCorrectas (index) {
        let vm = this
        var casilla
        for (casilla in vm.evaluacion.questions[index].response_option) {
          if (vm.evaluacion.questions[index].response_option[casilla].response_option_correct === 1) {
            vm.correctasCasillas.push(vm.evaluacion.questions[index].response_option[casilla].id)
          }
        }
      },
      cargarAlternativas () {
        let vm = this
        var arregloPregutas = {}
        var preguntitas = []
        for (var index in vm.evaluacion.questions) {
          vm.prguntasNuevas.push(preguntitas)
          var aux = vm.prguntasNuevas.length - 1
          if (index === aux) {
            for (var index2 in vm.evaluacion.questions[index].response_option) {
              arregloPregutas.texto = vm.evaluacion.questions[index].response_option[index2].response_options_test
              arregloPregutas.value = 0
              vm.prguntasNuevas[index].push(arregloPregutas)
            }
          }
        }
      },
      addAlternativa (model, index) {
        let vm = this
        if (vm.evaluacion.questions[index].type_question_id !== 5) {
          vm.evaluacion = model
          var alternativa = {}
          var posicion
          posicion = 0
          if (vm.evaluacion.questions[index].response_option.length !== 0) {
            posicion = vm.evaluacion.questions[index].response_option.length
            alternativa.id = posicion
          } else {
            alternativa.id = 0
          }
          alternativa.response_options_test = 'Opción 1'
          alternativa.response_option_correct = 0
          alternativa.type_response_id = 3
          vm.evaluacion.questions[index].response_option.push(alternativa)
        }
      },
      addTransaccion (model, index) {
        let vm = this
        vm.$delete(vm.evaluacion.questions[index].response_option, 0)
        var codigo = {}
        codigo.response_options_test = '*'
        codigo.response_option_correct = 1
        codigo.type_response_id = 1
        var transaccion = {}
        transaccion.response_options_test = '*'
        transaccion.response_option_correct = 1
        transaccion.type_response_id = 2
        vm.evaluacion.questions[index].response_option.push(codigo)
        vm.evaluacion.questions[index].response_option.push(transaccion)
      },
      removeTransaccion (index, index2) {
        let vm = this
        vm.$delete(vm.evaluacion.questions[index].response_option, index2)
        vm.$delete(vm.evaluacion.questions[index].response_option, index2)
      },
      removeAlternativa (index, index2) {
        let vm = this
        vm.$delete(vm.evaluacion.questions[index].response_option, index2)
      },
      addAlternativaCorrecta (index, id) {
        let vm = this
        var alternativa
        for (alternativa in vm.evaluacion.questions[index].response_option) {
          if (vm.evaluacion.questions[index].response_option[alternativa].id === id) {
            vm.evaluacion.questions[index].response_option[alternativa].response_option_correct = 1
          } else {
            vm.evaluacion.questions[index].response_option[alternativa].response_option_correct = 0
          }
        }
      },
      addPregunta (model) {
        let vm = this
        vm.evaluacion = model
        var pregunta = {}
        pregunta.question_text = 'Pregunta'
        pregunta.response_option = []
        pregunta.questions_point = 0
        pregunta.type_question_id = 0
        vm.evaluacion.questions.push(pregunta)
      },
      console (index, index2) {
      },
      submitTest (model) {
        let vm = this
        testService.save(model).then(data => {
          vm.lessons = data.body
          vm.mensajeToast('success', true, 'Prueba guardada con éxito')
        }, response => {
        })
      },
      cambioTipoLeccion (leccion) {
        this.tipodeleccion = leccion.typeLesson
      },
      cambiarEditable () {
        this.editable = false
      },
      cambiarEditableTrue () {
        this.editable = true
      },
      procesarArchivo (event) {
        var vm = this
        vm.archivo.file = event.target.files[0]
      },
      mensajeToast (color, snack, texto) {
        let vm = this
        vm.colorSnackbar = color
        vm.snackbar = snack
        vm.textSnackbar = texto
      },
      mensajeDelete (dialog, id, acction) {
        let vm = this
        vm.dialogDeleteElement = dialog
        vm.elementDelete = id
        vm.acctionDelete = acction
      },

      cambiarEstadoLeccion (id) {
        let vm = this
        changeTheStatusOfTheLessonService.update(id, vm.curso).then(data => {
          vm.lecciones = data.body
        })
      },
      cambiarEstadoTest (id) {
        let vm = this
        changeTheStatusOfTheTestService.update(id, vm.curso).then(data => {
          vm.pruebas = data.body
        })
      },
      verCursosCreados () {
        this.$router.push({name: 'cursesCreated'})
      },
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },
      volver () {
        this.$router.back()
      }
    },
    mounted () {
      let vm = this
      // cambiar id del curso
      vm.idCurso = 1
      vm.idEvaluacion = vm.$route.params.id
      vm.loadCurso()
      vm.loadTipoCompetencia()
      vm.loadNiveles()
      vm.loadPrueba()
      vm.loadCategorias()
      vm.loadUnidades(vm.idCurso)
      vm.loadPruebas(vm.idCurso)
      vm.loadTypeLesson()
      vm.loadPreguntasTipo()
      vm.loadEvaluacionesTipo()
    }
  }
</script>

<style scoped>

.panelDerechaLeccion{
  background-color: white;
  min-height: 500px;
  margin-top: 10px;
}

.boton-derecha {
  width: 200px;
}


.enlace{
  text-decoration:none;
}

.estilo-p {
  color: white;
  margin-bottom: 0px
}

.color-tab{
  background-color: #747474;
}

  .float_trans{
    margin-top: 5%;
    background: rgba(235, 99, 48, 0.8);
    filter: alpha(opacity=30); /*For IE8 and earlier*/
  }

.toolbar-misCursos{
  padding: 0.2em;
  margin: 0.5em;


}

.expansion-panel__header {
  padding: 0px !important;
}

.color-primary{
  background-color: #EB6330;
}


.color-primary-letra{
  color: #EB6330;
}

.btn-flotante {
transform-origin: center center 0px; margin-top: 20%;
margin-right: 5%
}

.btn-flotante-save {
transform-origin: center center 0px; margin-top: 10%;
margin-right: 5%
}

.herder-table{
  border-bottom: 2px solid #e65100; border-left: 2px solid #e65100; border-right: 2px solid #e65100;
}

.bordes {
border-left: 5px solid #e65100;border-right: 5px solid #e65100;border-bottom: 5px solid #e65100;
}

.bb-blanco {
  border-bottom: 2px solid white ;
}

.bl-blanco {
  border-left: 2px solid white ;
}
.bl-accent {
  border-left: 20px solid #00897b ;
}
.br-grisOscuro {
  border-right: 20px solid #e6e6e6 ;
}

.fondo-gris {
  background-color:  #f0f0f0;
}
.cursor-pointer {
  cursor: pointer;
}

/* Ripple effect */
.ripple {
  background-position: center;
  transition: background 0.8s;
}
.ripple:hover {
  background: #47a7f5 radial-gradient(circle, transparent 1%, #47a7f5 1%) center/15000%;
}
.ripple:active {
  background-color: #6eb9f7;
  background-size: 100%;
  transition: background 0s;
}
</style>




// WEBPACK FOOTER //
// src/components/Curso/EditEvaluacion.vue